function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from "react";
import BiArrowBack from "@meronex/icons/bi/BiArrowBack";
import { currencyToIndianRsWord, projectStatus } from "../../../../utils/helpers";
import IosArrowBack from "@meronex/icons/ios/IosArrowBack";
import BsArrowLeft from "@meronex/icons/bs/BsArrowLeft";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ProjectDetailNew(_ref) {
  var _projectDetails$apart, _projectDetails$apart2, _projectDetails$apart3, _projectDetails$apart4, _projectDetails$apart5, _projectDetails$apart6;
  var projectDetails = _ref.projectDetails,
    config = _ref.config,
    history = _ref.history,
    location = _ref.location;
  var queryParams = new URLSearchParams(location.search);
  var backClickHandler = function backClickHandler() {
    history.push("/projects");
  };
  var getApartmentText = function getApartmentText(apartmentTypes) {
    var _apartmentTypes, _apartmentTypes2;
    // console.log(apartmentTypes)
    if (!((_apartmentTypes = apartmentTypes) !== null && _apartmentTypes !== void 0 && _apartmentTypes.length) > 0) return;
    var ans = [];
    apartmentTypes = apartmentTypes.sort();
    (_apartmentTypes2 = apartmentTypes) === null || _apartmentTypes2 === void 0 || _apartmentTypes2.map(function (type) {
      switch (type) {
        case "_1_RK":
          ans = ["1 RK"].concat(_toConsumableArray(ans));
          break;
        case "_1_BHK":
          ans = [].concat(_toConsumableArray(ans), ["1"]);
          break;
        case "_1_5_BHK":
          ans = [].concat(_toConsumableArray(ans), ["1.5"]);
          break;
        case "_2_BHK":
          ans = [].concat(_toConsumableArray(ans), ["2"]);
          break;
        case "_2_5_BHK":
          ans = [].concat(_toConsumableArray(ans), ["2.5"]);
          break;
        case "_3_BHK":
          ans = [].concat(_toConsumableArray(ans), ["3"]);
          break;
        case "_3_5_BHK":
          ans = [].concat(_toConsumableArray(ans), ["3.5"]);
          break;
        case "_4_BHK":
          ans = [].concat(_toConsumableArray(ans), ["4"]);
          break;
        case "_4_5_BHK":
          ans = [].concat(_toConsumableArray(ans), ["4.5"]);
          break;
        case "_5_BHK":
          ans = [].concat(_toConsumableArray(ans), ["5"]);
          break;
        case "_6_BHK":
          ans = [].concat(_toConsumableArray(ans), ["6"]);
          break;
        case "Studio":
          ans = [].concat(_toConsumableArray(ans), ["Studio"]);
          break;
        default:
          break;
      }
    });
    // ans=ans.sort();
    if (ans.includes("1 RK") && ans.length === 1) return "1 RK";else if (ans.length === 1) return ans[0] + " BHK";
    var response = "";
    for (var i = 0; i < ans.length; i++) {
      if (ans[i] === "1RK") {
        response = "1 RK" + (i !== ans.length - 1 && ans.length > 2 ? ", " : "");
      } else {
        if (i === ans.length - 1) response = response + " & " + ans[i];else if (i === ans.length - 2) response = response + ans[i];else response = response + ans[i] + ", ";
      }
    }
    return response + " BHK";
  };
  var currencyFormating = function currencyFormating(price) {
    if (price >= 10000000) return currencyToIndianRsWord.format(price).slice(0, -2).concat(" Cr*");
    return currencyToIndianRsWord.format(price).slice(0, -1).concat(" L");
  };
  // console.log('project details', projectDetails)
  return /*#__PURE__*/_jsx("div", {
    className: "z-20 px-6 lg:px-0 2xl:px-8",
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col",
      children: [/*#__PURE__*/_jsx("div", {
        onClick: backClickHandler,
        className: "absolute  flex justify-center items-center top-8 lg:top-2 lg:left-2 rounded-full h-10 w-10 bg-[#ffffffb3] cursor-pointer",
        children: /*#__PURE__*/_jsx(BsArrowLeft, {
          className: "text-black w-6 h-full"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "flex my-6",
        children: /*#__PURE__*/_jsxs("div", {
          className: "z-10 flex-1 ".concat(config.fontBody),
          children: [/*#__PURE__*/_jsx("p", {
            className: "z-10 clear-both text-lg xl:text-2xl font-bold ".concat(config.fontTitle),
            children: projectDetails.projectName
          }), /*#__PURE__*/_jsx("p", {
            className: "z-10 text-[#908F95] italic pb-1 ",
            children: projectDetails.city
          }), /*#__PURE__*/_jsx("button", {
            className: "p-[4px] px-2 text-[#4652A4] bg-[#4652A433] mt-1 rounded",
            children: projectStatus(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.status)
          })]
        })
      }), /*#__PURE__*/_jsxs("svg", {
        viewBox: "0 0 457 2",
        children: [/*#__PURE__*/_jsx("defs", {}), /*#__PURE__*/_jsx("g", {
          id: "Layer_2",
          "data-name": "Layer 2",
          children: /*#__PURE__*/_jsx("g", {
            id: "Layer_1-2",
            "data-name": "Layer 1",
            children: /*#__PURE__*/_jsx("polygon", {
              "class": "cls-1",
              points: "0 1 57.13 0.51 114.25 0.23 228.5 0 342.75 0.23 399.88 0.51 457 1 399.88 1.49 342.75 1.77 228.5 2 114.25 1.76 57.13 1.49 0 1",
              fill: "#e5e5e5"
            })
          })
        })]
      }), /*#__PURE__*/_jsx("p", {
        className: "mt-4 text-lg ".concat(config.fontTitle),
        children: "Project Details"
      }), /*#__PURE__*/_jsxs("div", {
        className: "".concat(config.fontBody, " z-10 flex flex-wrap gap-y-4 text-[14px] my-4"),
        children: [/*#__PURE__*/_jsxs("div", {
          className: "w-1/2 lg:w-full xl:w-1/2",
          children: [/*#__PURE__*/_jsx("p", {
            className: " z-10 text-[#5E6164] tracking-widest ".concat(config.fontTitle),
            children: "AREA"
          }), /*#__PURE__*/_jsx("p", {
            className: "font-bold z-10 text-[16px]",
            children: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.area
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "w-1/2",
          children: [/*#__PURE__*/_jsx("p", {
            className: "z-10  text-[#5E6164] tracking-widest ".concat(config.fontTitle),
            children: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.type) == "COMMERCIAL" ? "TYPE" : projectDetails !== null && projectDetails !== void 0 && (_projectDetails$apart = projectDetails.apartmentTypes) !== null && _projectDetails$apart !== void 0 && _projectDetails$apart.includes("Plot") ? projectDetails !== null && projectDetails !== void 0 && (_projectDetails$apart2 = projectDetails.apartmentTypes) !== null && _projectDetails$apart2 !== void 0 && _projectDetails$apart2.includes("Plot") ? "PLOTS" : "VILLA" : "APARTMENTS"
          }), (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.type) == "COMMERCIAL" && /*#__PURE__*/_jsx("p", {
            className: "z-10 font-bold",
            children: "Commercial"
          }), (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.type) !== "COMMERCIAL" && /*#__PURE__*/_jsxs("p", {
            className: "z-10 font-bold  text-[16px] ",
            children: [projectDetails !== null && projectDetails !== void 0 && (_projectDetails$apart3 = projectDetails.apartmentTypes) !== null && _projectDetails$apart3 !== void 0 && _projectDetails$apart3.includes("Plot") || projectDetails !== null && projectDetails !== void 0 && (_projectDetails$apart4 = projectDetails.apartmentTypes) !== null && _projectDetails$apart4 !== void 0 && _projectDetails$apart4.includes("Villa") ? "Available" : getApartmentText(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.apartmentTypes), projectDetails !== null && projectDetails !== void 0 && (_projectDetails$apart5 = projectDetails.apartmentTypes) !== null && _projectDetails$apart5 !== void 0 && _projectDetails$apart5.includes("Plot") || projectDetails !== null && projectDetails !== void 0 && (_projectDetails$apart6 = projectDetails.apartmentTypes) !== null && _projectDetails$apart6 !== void 0 && _projectDetails$apart6.includes("Villa") ? "" : ""]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "w-1/2 z-10 mr-8",
          children: [/*#__PURE__*/_jsx("p", {
            className: " z-10 text-[#5E6164] tracking-widest ".concat(config.fontTitle),
            children: "STARTING"
          }), /*#__PURE__*/_jsx("p", {
            className: " font-bold text-[16px]",
            children: currencyFormating(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.price)
          })]
        })]
      }), /*#__PURE__*/_jsxs("svg", {
        viewBox: "0 0 457 2",
        children: [/*#__PURE__*/_jsx("defs", {}), /*#__PURE__*/_jsx("g", {
          id: "Layer_2",
          "data-name": "Layer 2",
          children: /*#__PURE__*/_jsx("g", {
            id: "Layer_1-2",
            "data-name": "Layer 1",
            children: /*#__PURE__*/_jsx("polygon", {
              "class": "cls-1",
              points: "0 1 57.13 0.51 114.25 0.23 228.5 0 342.75 0.23 399.88 0.51 457 1 399.88 1.49 342.75 1.77 228.5 2 114.25 1.76 57.13 1.49 0 1",
              fill: "#e5e5e5"
            })
          })
        })]
      })]
    })
  });
}